<script lang="ts">
  import { browser } from "$app/environment";
  import { hotkeysStore } from "$lib/stores/hotkeysStore";
  import { hotkeyActionsStore } from "$lib/utility/hotkeys";

  function handleKeydown(event: KeyboardEvent): void {
    if (!browser) return;

    // Update tableStore alt key state
    if ((event.metaKey || event.ctrlKey) && !event.shiftKey) {
      // setShortcutMode(true);
    }

    // Handle command menu toggle (Cmd/Ctrl + K)
    // if ((event.metaKey || event.ctrlKey) && !event.shiftKey && event.key.toLowerCase() === "k") {
    //   event.preventDefault();
    //   event.stopPropagation();
    //   hotkeysStore.toggleOpen();
    //   showKeyboardShortcuts.set(false);
    //   return;
    // }

    // Handle other hotkeys
    for (const hotkey of $hotkeyActionsStore) {
      if (hotkey.keyMatcher && hotkey.keyMatcher(event)) {
        if (hotkey.isEnabled && !hotkey.isEnabled()) continue;
        event.preventDefault();
        event.stopPropagation();
        hotkeysStore.setOpen(false);
        hotkey.action(event);
        return;
      }
    }
  }

  function handleKeyup(event: KeyboardEvent): void {
    if (!browser) return;
    if (event.metaKey || event.ctrlKey) {
      // setShortcutMode(false);
    }
  }
</script>

<svelte:window on:keydown|capture={handleKeydown} on:keyup|capture={handleKeyup} />
